module.exports = __webpack_public_path__ + "static/il-employment-quality-benefits-poster-f51fa8911881e3b35f08ac2a8b1d3ed5.pdf";